<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-07-10 13:48:42   showCollapseButton
-->
<template>
    <div>
        <a-menu
            :collapsed-width="55" 
            :theme="theme" 
            :collapsed="collapsed"
            :selected-keys="selectedKeys"
            :default-open-keys="['OrderList', 'Deliver', 'Outbounds', 'Customers']"
            :accordion="false"
            @menu-item-click="menuItemClick"
        >
            <template v-for="item in menu" :key="item.key">
                <template v-if="!item.children">
                    <router-link :to="item.link">
                        <a-menu-item  :key="item.key">
                            <template #icon>
                                <component :is="$arcoVueIcon[item.icon]" :size="17"></component>
                            </template>
                            {{ $t(`${item.locale}`) }}
                        </a-menu-item>
                    </router-link>
                </template>
                <template v-else>
                    <SubMenu :key="item.key" :subMenu="item"></SubMenu>
                </template>
            </template>

        </a-menu>
    </div>
</template>

<script setup>
    import { ref, watch} from 'vue';
    import { useRoute } from 'vue-router';
    import SubMenu from './SubMenu.vue';


    const route = useRoute()
    const props = defineProps({
        menu:{
            type:Array,
            default:()=>[]
        }
    })

    // console.log(route,'rrttt')

    const theme = ref('dark')
    const collapsed  = ref(false)
    const selectedKeys = ref(route.name)

    const menuItemClick = (key)=>{
        // console.log(key,'kkk')
        selectedKeys.value = key
    }

    defineExpose({
        collapsed
    })

    watch(
        ()=>route.path,
        (val)=>{
            // console.log(val,'router',route)
        }
    )
</script>

<style lang="less" scoped>
/deep/ .arco-menu-vertical{
    // 一级菜单保持原样
    .arco-menu-item, 
    .arco-menu-group-title, 
    .arco-menu-pop-header, 
    .arco-menu-inline-header{
        padding: 5px 5px 5px 10px;
        font-size: 12px;
    }
    
    // 只修改二级菜单项样式
    .arco-menu-sub .arco-menu-item {
        padding: 4px 5px 4px 15px !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        min-height: 30px !important;
        height: 30px !important;
    }
    
    // 子菜单内容区域高度调整（只在展开的子菜单中）
    .arco-menu-inline .arco-menu-item {
        padding: 4px 5px 4px 15px !important;
        font-size: 11px !important;
        line-height: 1.2 !important;
        min-height: 30px !important;
        height: 30px !important;
    }
}

</style>